export default "__VITE_ASSET__1b6363e5__"